(() => {
  const input = document.getElementById('NZSearch');
  const list = document.getElementById('DZSearchResults');
  const status = document.getElementById('DZSearchStatus');
  if (!input || !list) return;
  let timer;
  let controller;
  let selected = -1;
  let links = [];
  const close = () => { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); selected = -1; };
  const select = (index) => {
    if (!links.length) return;
    selected = (index + links.length) % links.length;
    links.forEach((link, i) => link.parentElement.setAttribute('aria-selected', String(i === selected)));
    input.setAttribute('aria-activedescendant', links[selected].parentElement.id);
    links[selected].scrollIntoView({block: 'nearest'});
  };
  input.addEventListener('input', () => {
    clearTimeout(timer);
    controller?.abort();
    close();
    const term = input.value.trim();
    if (term.length < 2) { list.replaceChildren(); links = []; return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      const params = new URLSearchParams({q: term, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][fields]': 'title,product_type,tag,variants.title,variants.sku', 'resources[options][unavailable_products]': 'last'});
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'search/suggest.json?' + params, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (input.value.trim() !== term) return;
        list.replaceChildren();
        const products = data.resources?.results?.products || [];
        products.forEach((product, index) => {
          const url = new URL(product.url, location.origin);
          if (url.origin !== location.origin) return;
          const item = document.createElement('li');
          item.id = 'DZSearchOption-' + index;
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', 'false');
          const link = document.createElement('a');
          link.href = url.pathname + url.search;
          link.tabIndex = -1;
          const title = document.createElement('span');
          title.textContent = product.title;
          link.append(title);
          item.append(link);
          list.append(item);
        });
        links = [...list.querySelectorAll('a')];
        if (links.length) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); status.textContent = links.length + ' ' + list.getAttribute('aria-label'); }
        else status.textContent = list.dataset.empty || '';
      } catch (error) {
        if (error.name !== 'AbortError') { close(); status.textContent = list.dataset.error || ''; }
      }
    }, 250);
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { clearTimeout(timer); controller?.abort(); close(); }
    if (list.hidden) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); select(selected + (event.key === 'ArrowDown' ? 1 : -1)); }
    if (event.key === 'Enter' && selected >= 0) { event.preventDefault(); links[selected].click(); }
    if (event.key === 'Tab') close();
  });
  document.addEventListener('click', (event) => { if (!event.target.closest('.dz-search-wrap')) close(); });
  input.form.addEventListener('submit', () => { clearTimeout(timer); controller?.abort(); close(); });
})();
